module.exports = __webpack_public_path__ + "static/improvised_shield-5c513674eecb6880a51ed2b2ef42b15e.jpg";